require('./link.sass');
up.link = (function () {
    const u = up.util;
    const e = up.element;
    let lastTouchstartTarget = null;
    let lastMousedownTarget = null;
    let lastInstantTarget = null;
    const ATTRS_WITH_LOCAL_HTML = '[up-content], [up-fragment], [up-document]';
    const ATTRS_SUGGESTING_FOLLOW = `${ATTRS_WITH_LOCAL_HTML}, [up-target], [up-layer], [up-transition], [up-preload]`;
    const DEFAULT_INTERACTIVE_ELEMENT = 'a[href], button';
    const config = new up.Config(() => ({
        followSelectors: ['[up-follow]', `a:is(${ATTRS_SUGGESTING_FOLLOW})`],
        noFollowSelectors: ['[up-follow=false]', 'a[download]', 'a[target]', 'a[href^="javascript:"]', 'a[href^="mailto:"]', 'a[href^="tel:"]', `a[href^="#"]:not(${ATTRS_WITH_LOCAL_HTML})`, e.crossOriginSelector('href'), e.crossOriginSelector('up-href')],
        instantSelectors: ['[up-instant]'],
        noInstantSelectors: ['[up-instant=false]', '[onclick]'],
        preloadSelectors: ['[up-preload]'],
        noPreloadSelectors: ['[up-preload=false]'],
        clickableSelectors: ['[up-clickable]', '[up-follow]', '[up-emit]', '[up-accept]', '[up-dismiss]', `a:is(${ATTRS_SUGGESTING_FOLLOW})`],
        noClickableSelectors: ['[up-clickable=false]', DEFAULT_INTERACTIVE_ELEMENT],
        preloadDelay: 90,
    }));
    function isPreloadDisabled(link) {
        return !up.browser.canPushState() || !isFollowable(link) || !willCache(link);
    }
    function willCache(link) {
        const options = parseRequestOptions(link);
        if (options.url) {
            if (options.cache == null) {
                options.cache = 'auto';
            }
            options.basic = true;
            const request = new up.Request(options);
            return request.willCache();
        }
    }
    function reset() {
        lastTouchstartTarget = null;
        lastMousedownTarget = null;
        lastInstantTarget = null;
    }
    const follow = up.mockable(function (link, options, parserOptions) {
        return up.render(followOptions(link, options, parserOptions));
    });
    function parseRequestOptions(link, options, parserOptions) {
        options = u.options(options);
        const parser = new up.OptionsParser(link, options, Object.assign(Object.assign({}, parserOptions), { fail: false }));
        options.url = followURL(link, options);
        options.method = followMethod(link, options);
        parser.json('headers');
        parser.json('params');
        parser.booleanOrString('cache');
        parser.booleanOrString('expireCache');
        parser.booleanOrString('evictCache');
        parser.booleanOrString('revalidate');
        parser.booleanOrString('abort');
        parser.boolean('abortable');
        parser.boolean('background');
        parser.string('contentType');
        parser.booleanOrNumber('lateDelay');
        parser.number('timeout');
        parser.booleanOrString('fail');
        return options;
    }
    function followOptions(link, options, parserOptions) {
        var _a;
        link = up.fragment.get(link);
        options = u.options(options);
        const parser = new up.OptionsParser(link, options, Object.assign({ fail: true }, parserOptions));
        parser.include(parseRequestOptions);
        options.origin || (options.origin = link);
        parser.boolean('navigate', { default: true });
        parser.string('confirm', { attr: ['up-confirm', 'data-confirm'] });
        parser.string('target');
        parser.booleanOrString('fallback');
        parser.string('match');
        parser.string('document');
        parser.string('fragment');
        parser.string('content');
        parser.boolean('keep', { attr: 'up-use-keep' });
        parser.boolean('hungry', { attr: 'up-use-hungry' });
        parser.json('data', { attr: 'up-use-data' });
        parser.json('dataMap', { attr: 'up-use-data-map' });
        parser.renderCallback('onLoaded');
        parser.renderCallback('onRendered');
        parser.renderCallback('onFinished');
        parser.renderCallback('onOffline');
        parser.renderCallback('onError');
        parser.booleanOrString('peel');
        parser.string('layer');
        parser.string('baseLayer');
        parser.json('context');
        parser.string('mode');
        parser.string('align');
        parser.string('position');
        parser.string('class');
        parser.string('size');
        parser.booleanOrString('dismissible');
        parser.renderCallback('onOpened');
        parser.renderCallback('onAccepted');
        parser.renderCallback('onDismissed');
        parser.string('acceptEvent');
        parser.string('dismissEvent');
        parser.string('acceptFragment');
        parser.string('dismissFragment');
        parser.string('acceptLocation');
        parser.string('dismissLocation');
        parser.booleanOrString('closeAnimation');
        parser.string('closeEasing');
        parser.number('closeDuration');
        parser.include(up.status.statusOptions);
        parser.booleanOrString('focus');
        parser.booleanOrString('focusVisible');
        parser.boolean('saveScroll');
        parser.boolean('saveFocus');
        parser.booleanOrNumberOrString('scroll');
        parser.json('scrollMap');
        parser.boolean('revealTop');
        parser.number('revealMax');
        parser.number('revealPadding');
        parser.number('revealSnap');
        parser.string('scrollBehavior');
        parser.booleanOrString('history');
        parser.booleanOrString('location');
        parser.booleanOrString('title');
        parser.boolean('metaTags');
        parser.booleanOrString('lang');
        parser.include(up.motion.motionOptions);
        (_a = options.guardEvent) !== null && _a !== void 0 ? _a : (options.guardEvent = up.event.build('up:link:follow', { log: ['Following link %o', link] }));
        return options;
    }
    function preload(link, options) {
        link = up.fragment.get(link);
        let issue = preloadIssue(link);
        if (issue) {
            return Promise.reject(new up.Error(issue));
        }
        const guardEvent = up.event.build('up:link:preload', { log: ['Preloading link %o', link] });
        return follow(link, Object.assign(Object.assign(Object.assign(Object.assign({ abort: false, abortable: false, background: true, cache: true }, options), up.RenderOptions.NO_INPUT_INTERFERENCE), up.RenderOptions.NO_PREVIEWS), { guardEvent, preload: true }));
    }
    function preloadIssue(link) {
        if (!isSafe(link)) {
            return 'Will not preload an unsafe link';
        }
    }
    function followMethod(link, options = {}) {
        return u.normalizeMethod(options.method || link.getAttribute('up-method') || link.getAttribute('data-method'));
    }
    function followURL(link, options = {}) {
        const url = options.url || link.getAttribute('up-href') || link.getAttribute('href');
        if (url !== '#') {
            return url;
        }
    }
    function isFollowable(link) {
        link = up.fragment.get(link);
        return config.matches(link, 'followSelectors');
    }
    function makeFollowable(link) {
        if (!isFollowable(link)) {
            link.setAttribute('up-follow', '');
        }
    }
    function makeClickable(element) {
        let role = element.matches('a, [up-follow]') ? 'link' : 'button';
        e.setMissingAttrs(element, {
            tabindex: '0',
            role,
            'up-clickable': ''
        });
        element.addEventListener('keydown', function (event) {
            if ((event.key === 'Enter') || (element.role === 'button' && event.key === 'Space')) {
                return forkEventAsUpClick(event);
            }
        });
    }
    up.macro(config.selectorFn('clickableSelectors'), makeClickable);
    function shouldFollowEvent(event, link) {
        if (event.defaultPrevented) {
            return false;
        }
        const betterTargetSelector = `a, [up-follow], ${up.form.fieldSelector()}`;
        const betterTarget = event.target.closest(betterTargetSelector);
        return !betterTarget || (betterTarget === link);
    }
    function isInstant(linkOrDescendant) {
        const element = linkOrDescendant.closest(config.selector('instantSelectors'));
        return element && !isInstantDisabled(element);
    }
    function isInstantDisabled(link) {
        return config.matches(link, 'noInstantSelectors') || config.matches(link, 'noFollowSelectors');
    }
    function convertClicks(layer) {
        layer.on('click', function (event, element) {
            if (up.event.isModified(event)) {
                return;
            }
            if (isInstant(element) && lastInstantTarget === element) {
                up.event.halt(event);
            }
            else if (up.event.inputDevice === 'key' || up.event.isSyntheticClick(event) || (layer.wasHitByMouseEvent(event) && !didUserDragAway(event))) {
                forkEventAsUpClick(event);
            }
            lastMousedownTarget = null;
            lastInstantTarget = null;
        });
        layer.on('touchstart', { passive: true }, function (event, element) {
            lastTouchstartTarget = element;
        });
        layer.on('mousedown', function (event, element) {
            if (up.event.isModified(event)) {
                return;
            }
            lastMousedownTarget = element;
            if (isInstant(element) && !isLongPressPossible(event)) {
                lastInstantTarget = element;
                forkEventAsUpClick(event);
            }
            lastTouchstartTarget = null;
        });
    }
    function isLongPressPossible(mousedownEvent) {
        let mousedownTarget = mousedownEvent.target;
        return (lastTouchstartTarget === mousedownTarget) && mousedownTarget.closest('[href]');
    }
    function didUserDragAway(clickEvent) {
        return lastMousedownTarget && (lastMousedownTarget !== clickEvent.target);
    }
    function forkEventAsUpClick(originalEvent) {
        let forwardedProps = ['clientX', 'clientY', 'button', ...up.event.keyModifiers];
        const newEvent = up.event.fork(originalEvent, 'up:click', forwardedProps);
        up.emit(originalEvent.target, newEvent, { log: false });
    }
    function isSafe(link) {
        const method = followMethod(link);
        return up.network.isSafeMethod(method);
    }
    function onLoadCondition(condition, link, callback) {
        switch (condition) {
            case 'insert':
                callback();
                break;
            case 'reveal': {
                let margin = e.numberAttr(link, 'up-intersect-margin');
                up.fragment.onFirstIntersect(link, callback, { margin });
                break;
            }
            case 'hover':
                new up.LinkFollowIntent(link, callback);
                break;
            case 'manual':
                break;
        }
    }
    function loadDeferred(link, options) {
        let guardEvent = up.event.build('up:deferred:load', { log: ['Loading deferred %o', link] });
        let forcedOptions = Object.assign({ navigate: false, guardEvent }, options);
        let defaults = {
            target: ':origin',
            cache: 'auto',
            revalidate: 'auto',
            feedback: true,
        };
        return follow(link, forcedOptions, { defaults });
    }
    up.attribute('up-defer', { defaultValue: 'insert' }, function (link, condition) {
        let doLoad = (options) => up.error.muteUncriticalRejection(loadDeferred(link, options));
        onLoadCondition(condition, link, doLoad);
    });
    up.on('up:click', config.selectorFn('followSelectors'), function (event, link) {
        if (shouldFollowEvent(event, link)) {
            up.event.halt(event, { log: true });
            up.focus(link, { preventScroll: true });
            up.error.muteUncriticalRejection(follow(link));
        }
    });
    up.attribute('up-expand', { defaultValue: 'a, [up-href]', macro: true }, function (area, childLinkSelector) {
        let childLink = e.get(area, childLinkSelector);
        if (childLink) {
            e.setMissingAttrs(area, Object.assign({ 'up-href': e.attr(childLink, 'href') }, e.upAttrs(childLink)));
            childLink.upExpandedPair = area.upExpandedPair = [area, childLink];
            e.addClasses(area, e.upClasses(childLink));
            makeFollowable(area);
        }
    });
    up.compiler(config.selectorFn('preloadSelectors'), function (link) {
        if (!isPreloadDisabled(link)) {
            let doPreload = (options) => up.error.muteUncriticalRejection(preload(link, options));
            let condition = e.booleanOrStringAttr(link, 'up-preload');
            if (condition === true || u.isUndefined(condition))
                condition = 'hover';
            onLoadCondition(condition, link, doPreload);
        }
    });
    up.on('up:framework:reset', reset);
    return {
        follow,
        followOptions,
        requestOptions: parseRequestOptions,
        preload,
        makeFollowable,
        isSafe,
        isFollowable,
        shouldFollowEvent,
        convertClicks,
        config,
        loadDeferred,
    };
})();
up.follow = up.link.follow;
up.deferred = { load: up.link.loadDeferred };
